import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'

import { mapApiStatusToUiStatus } from '@/features/campaigns/lib/quick-instrument-display'
import { directInstrumentOpenPath } from '@/features/instruments/lib'

import { DashboardIconAction, dashboardActionsRowSx } from './DashboardIconAction'

interface Props {
  instrumentId: string
  apiStatus: string
}

export function DashboardDirectInstrumentRowActions({
  instrumentId,
  apiStatus,
}: Readonly<Props>) {
  const navigate = useNavigate()
  const uiStatus = mapApiStatusToUiStatus(apiStatus)
  const href = directInstrumentOpenPath(instrumentId, apiStatus)

  if (uiStatus === 'Draft') {
    return (
      <Box sx={dashboardActionsRowSx}>
        <DashboardIconAction
          variant="continue"
          label="Continue Building"
          testId={`dashboard-direct-instrument-open-${instrumentId}`}
          onClick={() => navigate(href)}
        />
      </Box>
    )
  }

  return (
    <Box sx={dashboardActionsRowSx}>
      <DashboardIconAction
        variant="launch"
        label="Open dashboard"
        testId={`dashboard-direct-instrument-open-${instrumentId}`}
        onClick={() => navigate(href)}
      />
    </Box>
  )
}
